export const getSubscriptionPlanByGroup = (group) => (state) =>
  state.payment.subscriptionPlans.find((plan) => plan.subscriptionPlanGroup === group && !plan.zppCertified) ?? {};
